import { Controller } from '@hotwired/stimulus';

// Cycles a split-flap board through format pairs: MP4 → MP3, MOV → MP4…
// Text swaps at the animation midpoint, when the tile is edge-on.
// Tiles whose text doesn't change are left alone — so a locked target
// (e.g. the MP3 hub) sits still while the source side rolls.
export default class extends Controller {
  static targets = ['from', 'to'];
  static values = {
    pairs: Array,
    interval: { type: Number, default: 2400 },
  };

  connect() {
    this.index = 0;
    this.swapTimeouts = [];
    if (this.pairsValue.length > 1) {
      this.timer = setInterval(() => this.flip(), this.intervalValue);
    }
  }

  disconnect() {
    clearInterval(this.timer);
    this.swapTimeouts.forEach((timeout) => clearTimeout(timeout));
  }

  flip() {
    this.index = (this.index + 1) % this.pairsValue.length;
    const [from, to] = this.pairsValue[this.index];

    this.animate(this.fromTarget, from);
    this.animate(this.toTarget, to);
  }

  animate(tile, text) {
    if (tile.textContent.trim() === text) return;

    tile.classList.remove('flap-flipping');
    void tile.offsetWidth;
    tile.classList.add('flap-flipping');

    this.swapTimeouts.push(
      setTimeout(() => {
        tile.textContent = text;
      }, 220),
    );
  }
}
